export default __webpack_public_path__ + "static/logoblack-10d8dfd2a3ec6f190bf0c64492655909.svg";